<template>
  <b-row class="payment-step">
    <b-col cols="6" class="select-block">
      <div class="payment-title">Wire / Bank Transfer</div>
      <p>
        You will be billed and must be paid through a bank. By specifying the order number in the comments. After payment within a short time, the amount of {{ total }} {{ orderData.asset.symbol }} will be transferred to the address you specified to receive {{ orderData.asset.name }}
      </p>
      <e-button @click="nextPage('transfer')">Choose</e-button>
    </b-col>      
    <b-col cols="6" class="select-block">    
      <div class="payment-title">Credit or Debit Card (Soon)</div>
      <p>Simple and fast payment without additional confirmation using a credit or debit card. Cryptocurrency comes immediately after payment.</p>
      <p>Will be available soon!</p>
      <e-button disabled>Choose</e-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "step-payment-method",
  components: { },
  data() {
    return {
    };
  },
  methods: {
     ...mapActions("orders", ["getPaymentInfo"]),
    nextPage(type) {
      this.$emit('nextPage', type);
    }
  },
   computed: {
    ...mapGetters("orders", {
      orderData: 'buyModalData'
    }),
    total() {
      return (this.orderData.amount / this.orderData.asset.price.value).toFixed(6);
    }
  },
  mounted() {
    // this.fetchCoins();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/buyCrypto/stepPaymentMethod.vue